
function setOffset() {

  document.querySelectorAll('.investment-types').forEach(el => {
    var p = el.querySelectorAll('.investment-types__tab-content-text--active p')[0];
    //console.log('p', p.offsetTop);

    var chat = el.querySelectorAll('.investment-types__chat')[0];
    if (chat) {
      chat.style.marginTop = p.offsetTop + 'px';
    }

	});

}

function updateContent(parent, index) {

  var activeText = parent.getElementsByClassName('investment-types__tab-content-text--active')[0];
  //console.log('active', activeText);
  activeText.classList.remove("investment-types__tab-content-text--active");

  //var nextText = document.getElementsByClassName('investment-types__tab-content-' + index)[0];
  //nextText.classList.add("investment-types__tab-content-text--active");

  var nextText = parent.querySelector('#investment-types__tab-content-' + index);
  nextText.classList.add("investment-types__tab-content-text--active");
}

export default function investmentTypes() {

  if (document.querySelectorAll('.investment-types__chat').length) {
    setOffset();

    window.addEventListener('resize', _.debounce(() => {
      setOffset();
    }, 400));
  }

  document.querySelectorAll('.investment-types').forEach(el => {

    var select = el.querySelectorAll('.investment-types select');

    if (select.length) {
      select[0].addEventListener('change', function(e) {
        //console.log('select', this.value)

        var activeTab = el.getElementsByClassName('investment-types__tabs--active')[0];
        if (activeTab) {
          activeTab.classList.remove("investment-types__tabs--active");
        }

        updateContent(el, this.value);
      });
    }


    var links = el.querySelectorAll('.investment-types__tabs a');

    links.forEach(link => {
  		link.addEventListener('click', function(event) {

        event.preventDefault();


        // update tabs
        var activeTab = el.getElementsByClassName('investment-types__tabs--active')[0];
        //console.log('active', activeTab);
        if (activeTab) {
          activeTab.classList.remove("investment-types__tabs--active");
        }

        this.classList.add("investment-types__tabs--active");

        // update content

        updateContent(el, link.dataset.tab);


        setOffset();


  		});
  	});

  });


  if (window.location.hash) {
    //console.log('hash', window.location.hash)

    var hashSplit = window.location.hash.split('-');
    //console.log(hashSplit);

    if (hashSplit.length == 2) {

      var tabId = parseInt(hashSplit[1]);
      //console.log(tabId);

      var links = document.querySelectorAll('.investment-types__tabs a');
      links[tabId-1].click();
    }

  }
}
